import React, { Component } from 'react' // eslint-disable-line no-unused-vars
import constants from 'core/types'
import {
  BLOCK_NATIVE_DAPP_ID,
  APP_URL,
  CONTACT_EMAIL,
  INFURA_KEY
} from 'configs/config-main'
// import { AddressZero } from 'ethers/constants'
import { getStore } from 'core/store/configureStore'
import { setWallet } from 'core/actions/actions-wallet'
import { Web3Provider } from 'ethers/providers'
import { getRpcUrl } from 'core/libs/lib-rpc-helpers'
import { setInLocalStorage } from 'core/libs/lib-storage-helpers'
import { trackTransactionStatuses } from 'core/libs/lib-transaction-helpers'
import metaMaskWalletIconSvg from 'assets/icons/wallets/wallet-metamask.svg'
import ledgerWalletIconSvg from 'assets/icons/wallets/wallet-ledger.svg'
import trezorWalletIconSvg from 'assets/icons/wallets/wallet-trezor.svg'
import coinbaseWalletIconSvg from 'assets/icons/wallets/wallet-coinbase.svg'

async function fetchAndSetAccount(store, notional, signer, wallet) {
  let account

  const { wallet: walletState } = store.getState()
  if (walletState.walletProvider) {
    // If there is already a wallet connect we must reset it first
    store.dispatch({
      type: constants.RESET_WALLET
    })
  }

  try {
    const address = await signer.getAddress()

    if (address === 0x0) {
      store.dispatch({
        type: constants.SET_PROVIDER_AND_SDKS_ERROR,
        payload: {
          error: 'Address supplied is the zero address'
        }
      })

      store.dispatch({
        type: constants.RESET_WALLET
      })

      return
    }

    account = await notional.getAccount(signer)

    /* Start: Set up transaction event listeners */
    const txActionDispatchType = constants.SET_TRANSACTION_STATUS
    trackTransactionStatuses(address, store, txActionDispatchType, notional)
    /* End */

    account.onAccountUpdate((a) => {
      store.dispatch({
        type: constants.ACCOUNT_UPDATE,
        address: a.address
      })
    })
  } catch (error) {
    Sentry.captureException(error)
    store.dispatch({
      type: constants.SET_PROVIDER_AND_SDKS_ERROR,
      payload: {
        error: 'Could not fetch account'
      }
    })
    return
  }

  setInLocalStorage('selectedWallet', {
    walletProvider: {
      walletName: wallet.name,
      account: {
        address: account.address
      }
    }
  })

  store.dispatch(setWallet({
    walletProvider: {
      walletName: wallet.name,
      account,
      signer
    }
  }))
}

export function setOnboardSDK(notional, networkId) {
 
}

export function svgLoadWalletIcon(opts) {
  const { type } = opts
  let icon

  switch (type.toLowerCase()) {
    case 'metamask':
      icon = (<img
        className="wallet-icon"
        src={metaMaskWalletIconSvg}
        alt="MetaMask wallet icon"
      />)
      break
    case 'ledger':
      icon = (<img
        className="wallet-icon"
        src={ledgerWalletIconSvg}
        alt="Ledger wallet icon"
      />)
      break
    case 'trezor':
      icon = (<img
        className="wallet-icon"
        src={trezorWalletIconSvg}
        alt="Trezor wallet icon"
      />)
      break
    case 'coinbase':
      icon = (<img
        className="wallet-icon"
        src={coinbaseWalletIconSvg}
        alt="Coinbase wallet icon"
      />)
      break
    case 'authereum':
      icon = <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAxCAYAAAHfINuoAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAEB9JREFUWAm1WQtsXWUd/3/n3FfbdWOPbgNBAcHMbCBYYI5tvbdstLddN0RTJaBiRI1mQAi+EEQqZjAUNGGEGBQSI2pYFZB261rZ1nbLHrqqsE2DykNEYA8HWx/39t5zzufv9z/n3LXTMWPil9ye73zn//3fr++rSDRsLpfg1La0pI3NN/RK7ZxWKR7xpBS0md6tGxwFnN9pRQym/i9tR4cjtjn7sG3KflG31tcn+TSKq9o7V3yzVxKJlER7+FFsPrtekol2ycxI64IuRluPL7Q0LrZXNpx/fCGf/QrR2OYGq8+2ZZYsJWRFY2B6B43ksw8BOxaszBNjxK64wornFUndEdf5lOneYrAggK7CcwPFgABLfZl6pEoKc8YVIKZo87lPxHNQbVwhSadbyuUSUC02G/v3QBArpjojGb8oY8UxSbjVjhj/ZuC+HTTSCgR2QWSvBKMj8lapShZdUUvmQm2SPiSHTCqC2TR4IT52Sjp4Szo6sDEatg2ixPN89hUqga+2JdJ8c8OISqOLzUvHoZfLZOqsfTJ8cLsUzVJgLEkyaeSNt1MVQAWm4udOK4nv8/W3ZtPAZZxUhm2fn+KLbc1dpE/4CdzjLp2HrqBG+SdApqixL826smfQl5K9xPRtHVJeXcgbBD+l1CnTuy0tozZpOjoCKXvA4e+y7e2uODUZqMwAyXWqHtshjunv9+zKZVZcN6R47MAtpqcHAoajokd9LZXFbNxKAXfid69iDeEihb9e76pbJOkl8OPDo8vx3cixA10RHAFtIGes9GFGTz2iueE1MzRUBtzd4jgt8O5M6FOp1FQVwphnot2zlNfDI2tNDwTJ2L+I730rIaWxmbYlZ2XKeDUDBhRSUiqVQqzYGtiZpm+wwzG9O49AT8ekUDUmU2ffJAnnAlUXYKDHopScGTGf+oQlfqUeTIC2K96FeUU1BJhs69bGhbDzdsLCP9WsBDrp0Ag/4atRq3RIwHU4RZv4wYOI53NUoRu2GHWYkVk3QKh7QGW6Itm1ZQ0c+zasIWTM/XDJ29Wy4JDJZgM2L4OJ02CvDKOvFaleIz09JamvT8isGnrbbcqIMS5ctMKEbQIDxt4rqcQCxGYgxnHoEkxlZXB2h/QOZkzPwDcrPlNXsw7fvoSfC+0gS1gobpk1kUSmr79bFjV+wHRtpiMybxyPVYJLB7ZiqG/lG7qxcgNegco8LkfLDAGQLtMaGqIKfMKfyU7bQc1hDB/chtmVQA0x5PvyoYHr5cwzSwY6DZF6ot5F2P7+STiQh40ahN9gcwsvewrKRsRaxJV7hyRHvy39uRSIdDI7K9IUsjXiz65cbmkM7o0HsJsHsBk+Yr/BRdM7cLUk3Sogu1YSww9LaVZGqqUAZldI2j7KaFKdUf2l8nfoBTDsKhBgEh5WR4QLvwyEswG6C+WlyXR2+lorEokaSflvR0mI9IoQ4wnZNPgZbAxU1yOv1iDbHkUEiunebEL5Fw2+FyanEZZK4Z+ehmbdIcc8++xRxNGX4ErAZUtAVkBy/TRf8BM5dvAfEqQP0rpEptzrhwl/wO3reJ0BimlodDX87mFyolxDPNO5v6QGKaEmpJIpkDhNpr9R4DrRqMgT8FWmQAzOnPvBIfKVOQDjfU5c0wPxuZGloComVNmEyUkREkhFr62FWgqjyC00x/fB8a0TEZx0DvmdSqJngm/J3qdIIa5tzuV1jnIPzq+1rUveFyNi8YrnfMaKtHbV4lopJb6Htc+qEazJycFjO5jx7KrlVsrBeTJl5t+hy5K96kqrlve856GKG+Fq24hMjYIi+wwK60rEMjQTjGG9mtFAB2arIsEYYtneReXAwmlmJ9mZvQ1/18BxmAxdGAcpuPw6rH0V7G1WqlMmUFCMeR6fs4qMbywsSXcNNiVBPmVbGrOIGqTlgXvE8WcA4hH8EuJpsZwFhoCQtS2VUu+HwheJrdkNBBxoG5Y+AGLkgsazUEV/JdTeLIzIpoFbmM6AaD2+Q0RDbByhn3IWpy5gCCSVpkXROCFJEKnnlWGUT9EQ1K3C6KYoQDCPEJIBRasT+hd0+3O4CrlDU+RsgZ4JkkQ2/3GlNHHlhBEhnLzKqEAGvwaraSocYl0pXvAc3sehAh8utUYNNnmbvk1CCPaQk6G7fEM/xKOmi0CwTkXsHbgI3LFvdMVN3E7VEPZEnJMQar6j5G4iqxtTyQy4u1mGhtSMQL4B6x6ydhEq+QkZeEeEWrnyDb8Dd9QdG4W7lDsYiNwgftvAJWtQBr5a6SInIo04nEAombwYAGlsQCoYuFsjpTlbUHWwByt7aG+lBC7Hocu7NSdaWxGdjo3vlfdQi6yCnv9529RUY5cvn4bPGYoo89s9cHmTpi14LwTuUQMac65yaeVlB04ZVrJ87mxd9Lw+WDiJaPih6esbFbeEeLU+RWQbpMnA82+C6Ab6ZQcG5zOUKoOo2kiLPg1KjeBijxSd5lCPuWtg36eBuAZN6uGoBBSxaT04vJ44UMzuRDd0jxw5cprCMGujPhv74dxpUjJvUXSNYQS/6Yhak+aGV7F3Nn50FwiZ1E06j/4gcv6B6VSobbv0DrSq8rD4EhZPB5dlZBR8DIemqeI4XUbDRPVtzNWogd0yPp6Uaak81PFkTIie4LD5gRjnYhE9o01D+TuITtd/9WsDsYmsHIXe5Wgbn5aqKlemZd6NEvEkvqGR9r4W+3DIId1hdPrZCNUXYF3UEDkMImfENQNE3pCU9z6ZWyyaR5Bw89l2KGZ9WF+cvTDgJUCso+Iv9vNI5a9Wv1/c5HNwaJ5yUuzGlTKb8Ljy5RseghFXYzeShuyGipZEuCYj5JsWJU5q3QIbXkmmUnLJZle66l118Hz2d4iZBUCEOuLcZ3r7wzaPe6JR4TBeqHDU2si6AaQ4YfpyngTeXwADztFH2qBVpszuU6eON54MIdc1bvGA9Q/gdSqsmwFnZUknkzLuzpFp095msYpwTHpMyjbxF7CtwQ3DzIEnbAXqcXSpSW2SXPfoyZDF+0/5RFTcTiCq41TAFR1STMnl1IErhShEkkGcwJJo54xkocOLkb33wVUuUCKR9XWep4rMLxDjqzWjL+wpM+rQiy9AaOCoGzAtogiazWhrNvIYzH3xUIbr6qx0dgYVLVU+Nl0+W5xkFu+r8FsON5yrkRbWf6p0FMEyBf1AFxhYpaeL/ftxaEYruXJltZSO/gnw74YACB3/R4D5XExQYVqW1qHJ2A/m8LSjwFejsOwUScPaF7HWC5gucQo7TM/uY3hnKW/YJTVVC2W0wHemAUrJtIskH2YE5GgPoC8j2B5BJN9PQLZV2ik2NaHvLf4BUX06NMT9HrJCGo0JE93HFZadOWONqTpRvh/MNKkwrCUsijykB7agJR39Cei4yBYiY4UH0RLJUSAjnvGwZQ1egQs+hlDYKiPm+RPMrT6jVatzqGRbr3iPBMU9yFhsaogE8QhjlspFXBt8DJl7GgI9r8xBQlmyZFj27/8CNUqCHNDyFLjQxWCuCXRvAOMQ1OL+qERaoxOjBPlO6f8Ekj8gU+fuUwREHA0lRJ9jv9iGa6DA+yM+T2SOrsBfRspILG6iGQGhfkafYj2axBxx19WVZNzshCB3grntkdVgsXBMZDBa0pIqMr/Tw4nLj52VHzWB0+fo9GX5M1iphomoDWrOhwV4JOQWOJVJaSfjmnpo8kUtlMQxUWC+zp/vTbBSRRkA1fEfGIw/TX7S4bUi57OXakQqrQk4HAeHX+dsrFwr6TTx0pddBABP0OdKXc3f7Iol08l9zCy+n3L8VwzqBSOdPL90GTT0G/gbzUhpfdWYMT4MOM9s3PI3RO/PYd5r4C5xy4sAQPAYBJHvvGibGs5RF2lvx0n11OMdGVRpcbejTWU+ezV68WdBLMaKewloTewxOPX5ZtPWF7SF5m1pz+ATuOZZge/Ejx+6siBAdTTT8fsTBL0Qvlj6bzR5AoNUzPERaa6Iq6TrQOzJSHPk0EOexJEleBOamY+rpJeVGBMsO2QKtWlwo/h2sWLDJQmeLgSBv9o09jyHHmERNSmvd0W57DjdibMTGJzwieckEuNlsOs8jlwVRxY6bzDnB38XWzUfefE1276oSok151bjmjUHpy8yfYDxHdD6PA0kDZ4o05FR19nBW1htaHjzfJKBD2YkCqwwwAKpVdj+/tCWjqDf0OBiA4MzGcwaBC/J1Dnnmd7eI6wipnNnAenkqyjY66DVHpzjPggmR5RxmB7MnAnNDau/YgL8DBw87OlKK768tTakrYv8Y8YItb2S6TQ7WNxvRpISxjqPoMtnq5EBUtzt2P0w33vVh2jKrq4xLf4J9z5tqliBjNlpVzTWK+OE2dj/pnips4DjNXxjlUoiBb0iqeGfkYT6OoIHs0vCsqfRj9dgBxr/8k+R+Y9AMzjEewWUqcsk3/BJ3bQIpuvd+hxKT5tkGJR2D6J0AZFqqaMp87nbkFzXaM5jPrSoApoDcdEbahI+jMDhLU3RgAn7EhjErZ27xHQNjenRJuTyVlhgpgT+GA4QSVhpN4IN12Ek1tJwHbL+42AQDTBuuVycCrxgMX0ICFBzEXG8IFi4sCw0R3u7w4qAfV9Dj7sWGmaZYxlSfHgyeSMv4tU6F1HIuOfFemVobmX6as7dKCl3HRTF3Ikgwj7XXGA29O/DHWh0TZTPfh25657InC7m8DXvBkjxmPoS/SxigGR5SOa5FkgLYAuVfdKgn5FZXpFCG9KA9mxbTIuQlWYjn3sIGlsdMmeToOvgyqXJ9A38mvChJqilTQP3grnroXomUGgQR1rHfRTpYJ8cSoepoKWlklxxMr0DMN9DWxwzF0c56fPUQBaxz1ytzHWAVWodbkMAGZ4xDyVwFDAhc8bAh3B36clFyhwrF+AppQ7mMc3w2l3Y34PR88BA2Iez8S/7f5B0Im+e2XyAppFhXDXiYA8EAXztKphlPfw4pdHp+39Fesmbni0v6m3XoTrNCNpstOQ+hEjfAOFnIHXRpAZ+z2P3U1DSR8jMRE1XGFQu+TFmFFGIQ1k/GJ2CJxE5mCP/4aRi3Y/wX2lx0yqHDhklvjI3S8ZTBZ6qYyE0PxJvS+7L0OF3o+Y0FDxkbK+4Pu6utr8Vmz3mhU+mmUkjRihBBm39IP8LdSZk3A8pkRrIHN3L79aL611b16oZ6Oi846vPHZG+vkJcu6W2lrdHz+j1ZxCsDfejVpIxY56U+qW8pr9Qqk9nhy3xlehEhv5NgxM/cq7EeCPHeXPDOjSiN8JX+Uot0DxJOPhuSTltpqv/MD8wB0JT3cgGc9WXCUfzcwTyRRwwf8ApT7usJJyfbJySwXijhZNLB6s+dNja+FHkqSe0qoR+hBtCmj+AJlBrXSehrsB8kUxQ86/h7rXVbBzcq5oeGvKIJ8b9Ts9/M/HJgHk6qyC1mW6YBnnPnA3dvACt0jehZcsIxYka7VUKx3RcaMpIkATsWbjS/DNx04UqeLjw/xyavCMCKHcP89oY/29ijrwppqtRHL/8D89/AX4b8Jtu/BkFAAAAAElFTkSuQmCC" alt="Authereum wallet icon " />
      break
    default:
      icon = (<img
        className="wallet-icon"
        src={metaMaskWalletIconSvg}
        alt="MetaMask wallet icon"
      />)
  }

  return icon
}

export function accountHasLoaded(walletProvider) {
  const time = walletProvider?.account?.lastUpdateTime
  return time != null
}
